"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonValidator = exports.normalizeRefs = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const jsonschema_1 = require("jsonschema");
const json_schema_spec_7_json_1 = __importDefault(require("./json-schema-spec-7.json"));
const isRecord = (payload) => typeof payload === "object" && !Array.isArray(payload);
function normalizeRefs(object) {
    if (isRecord(object)) {
        const draft = { ...object };
        for (const [key, value] of Object.entries(draft)) {
            if (key === "$ref" && typeof value === "string") {
                if (value.startsWith("#") || value.startsWith("/")) {
                    draft[key] = value;
                }
                else {
                    draft[key] = `/${value}`;
                }
            }
            else {
                draft[key] = normalizeRefs(value);
            }
        }
        return draft;
    }
    else if (Array.isArray(object)) {
        return object.map(normalizeRefs);
    }
    return object;
}
exports.normalizeRefs = normalizeRefs;
class JsonValidator {
    constructor() {
        this.baseValidator = new jsonschema_1.Validator();
    }
    validateSchema(schema) {
        const metaValidator = new jsonschema_1.Validator();
        const res = metaValidator.validate(schema, json_schema_spec_7_json_1.default);
        return res;
    }
    validate(instance, schema) {
        return this.baseValidator.validate(instance, normalizeRefs(schema));
    }
    addSchema(schema, id) {
        const res = this.baseValidator.addSchema(normalizeRefs(schema), id);
        return res;
    }
    errorsText(errors) {
        const err = errors.map(err => err.toString()).join("\n");
        return err;
    }
}
exports.JsonValidator = JsonValidator;
